import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { buildApi, get, patch, post } from '@applyboard/redux-bees';
import { API_ROOT } from "../constants/consts";
import { getCsrf } from '@applyboard/ab-common';

// Original redux-bees `destroy` method does not allow sending a body. This fixes it.
var destroy = function destroy() {
  var placeholders = arguments.length <= 0 ? undefined : arguments[0];
  var body = arguments.length >= 2 ? arguments.length <= 1 ? undefined : arguments[1] : arguments.length <= 0 ? undefined : arguments[0];
  var options = arguments.length === 3 ? arguments.length <= 2 ? undefined : arguments[2] : {};
  return {
    placeholders: placeholders,
    options: _objectSpread({
      method: 'DELETE',
      mode: 'cors',
      body: body && JSON.stringify(body)
    }, options)
  };
};
var apiEndpoints = {
  getPaymentRequirementCategories: {
    method: get,
    path: '/api/v2/payment_requirement_categories'
  },
  getRequirementCategoriesApplicationStage: {
    method: get,
    path: '/api/application_stages/:id/requirement_categories'
  },
  getRequirementCategories: {
    method: get,
    path: '/api/requirement_categories'
  },
  getApplicationStages: {
    method: get,
    path: '/api/application_stages'
  },
  patchApplicationRequirementQuestion: {
    method: patch,
    path: '/api/application_requirements/:application_requirement_id/application_questions/:question_id'
  },
  getMultipleApplications: {
    method: get,
    path: '/api/applications'
  },
  createBulkNotes: {
    method: post,
    path: '/api/v0.1/notes/bulk_create'
  },
  postApplicationRequirementFromTemplate: {
    method: post,
    path: '/api/applications/:application_id/application_requirements'
  },
  deleteApplicationRequirementAdditionalAttachment: {
    method: destroy,
    path: '/api/application_requirements/:application_requirement_id/application_additional_attachments/:id'
  },
  postApplicationRequirementExternalLink: {
    method: post,
    path: '/api/application_requirements/:application_requirement_id/application_external_links'
  },
  deleteApplicationRequirementExternalLink: {
    method: destroy,
    path: '/api/application_requirements/:application_requirement_id/application_external_links/:id'
  },
  getRequirementTemplateList: {
    method: get,
    path: '/api/requirement_templates'
  },
  postApplicationRequirementQuestion: {
    method: post,
    path: '/api/application_requirements/:application_requirement_id/application_questions'
  },
  deleteApplicationRequirementQuestion: {
    method: destroy,
    path: '/api/application_requirements/:application_requirement_id/application_questions/:question_id'
  },
  patchApplicationRequirementOptional: {
    method: patch,
    path: '/api/application_requirements/:application_requirement_id/optional'
  },
  patchApplicationRequirementRequired: {
    method: patch,
    path: '/api/application_requirements/:application_requirement_id/required'
  },
  patchApplicationRequirementInactive: {
    method: patch,
    path: '/api/application_requirements/:application_requirement_id/inactive'
  },
  patchApplicationRequirementAnswer: {
    method: patch,
    path: '/api/application_requirements/:application_requirement_id/application_questions/:question_id/application_question_answers/:id/update_answer'
  },
  postApplicationRequirementAnswer: {
    method: post,
    path: '/api/application_requirements/:application_requirement_id/application_questions/:question_id/answer'
  },
  getCancellationReasons: {
    method: get,
    path: '/api/cancellation_reason'
  },
  getApplication: {
    method: get,
    path: '/api/applications/:id'
  },
  getSingleApplicationRequirement: {
    method: get,
    path: '/api/application_requirements/:id'
  },
  updateAttachment: {
    method: patch,
    path: '/awa/v1/application_requirements/:application_requirement_id/attachments/:id'
  },
  patchApplicationRequirementApproveAnswer: {
    method: patch,
    path: '/api/application_requirements/:application_requirement_id/application_questions/:question_id/application_question_answers/:id/approve'
  },
  patchApplicationRequirementDisapproveAnswer: {
    method: patch,
    path: '/api/application_requirements/:application_requirement_id/application_questions/:question_id/application_question_answers/:id/disapprove'
  },
  patchApplicationRequirementAnswerStatusNote: {
    method: patch,
    path: '/api/application_requirements/:application_requirement_id/application_questions/:question_id/application_question_answers/:id/update_note'
  },
  patchApplicationRequirement: {
    method: patch,
    path: '/api/application_requirements/:application_requirement_id'
  },
  patchApplicationRequirementReviewStatus: {
    method: patch,
    path: '/api/application_requirements/:application_requirement_id/review'
  },
  patchApplicationRequirementApproveStatus: {
    method: patch,
    path: '/api/awa/pages/applications/:application_id/data/requirements/:application_requirement_id/approve'
  },
  patchApplicationRequirementDisapproveStatus: {
    method: patch,
    path: '/api/awa/pages/applications/:application_id/data/requirements/:application_requirement_id/disapprove'
  },
  getApplicationVerifiedDocuments: {
    method: get,
    path: '/api/applications/:id/verified_documents'
  },
  // Application requirements
  getApplicationRequirements: {
    method: get,
    path: '/api/awa/pages/applications/:application_id/data/requirements'
  },
  postIeltsResults: {
    method: post,
    path: '/api/integrations/verify_ielts'
  },
  getConditionOperations: {
    method: get,
    path: '/api/condition_resources/operations'
  },
  getStudentTestScores: {
    method: get,
    path: '/api/students/:id/test_scores'
  },
  getEducationHistories: {
    method: get,
    path: '/api/students/:student_id/attended_schools'
  },
  getStudentCustomFields: {
    method: get,
    path: '/api/students/:id/custom_fields'
  },
  getApplicationCustomFields: {
    method: get,
    path: '/api/applications/:id/custom_fields'
  },
  getCountries: {
    method: get,
    path: '/api/v2/countries'
  },
  getConditionTemplate: {
    method: get,
    path: '/api/conditions/:id'
  },
  getConditionResourcesAttributes: {
    method: get,
    path: '/api/condition_resources/'
  },
  patchConditionTemplate: {
    method: patch,
    path: '/api/conditions/:id'
  },
  postConditionTemplate: {
    method: post,
    path: '/api/conditions'
  },
  getNoteTemplates: {
    method: get,
    path: '/api/note_templates/search'
  },
  getNoteTemplatesTagDefinitions: {
    method: get,
    path: '/api/note_templates/tag_definitions'
  },
  createNoteTemplate: {
    method: post,
    path: '/api/note_templates'
  },
  editNoteTemplate: {
    method: patch,
    path: '/api/note_templates/:id'
  },
  destroyNoteTemplate: {
    method: destroy,
    path: '/api/note_templates/:id'
  },
  getSchoolProgramIntakes: {
    method: get,
    path: '/api/v2/program_intakes'
  },
  getCustomFieldDefinitions: {
    method: get,
    path: '/api/custom_field_definitions'
  },
  postStudentCustomFields: {
    method: post,
    path: '/api/students/:id/custom_fields'
  },
  patchStudentCustomFields: {
    method: patch,
    path: '/api/students/:student_id/custom_fields/:id'
  },
  destroyStudentCustomFields: {
    method: destroy,
    path: '/api/students/:student_id/custom_fields/:id'
  },
  postApplicationCustomFields: {
    method: post,
    path: '/api/applications/:id/custom_fields'
  },
  patchApplicationCustomFields: {
    method: patch,
    path: '/api/applications/:application_id/custom_fields/:id'
  },
  destroyApplicationCustomFields: {
    method: destroy,
    path: '/api/applications/:application_id/custom_fields/:id'
  },
  createApplyStuEmail: {
    method: post,
    path: '/api/integrations/create_applyboard_email'
  }
};
var config = {
  baseUrl: API_ROOT,
  configureHeaders: function configureHeaders(headers) {
    return _objectSpread(_objectSpread({}, headers), {}, {
      'x-csrf-token': getCsrf(),
      'X-Requested-With': 'XMLHttpRequest'
    });
  },
  configureOptions: function configureOptions(options) {
    return _objectSpread(_objectSpread({}, options), {}, {
      credentials: 'include'
    });
  }
};
var jsonApi = buildApi(apiEndpoints, config);
export var getApplicationStagesAction = jsonApi.getApplicationStages;
export var getRequirementCategoriesAction = jsonApi.getRequirementCategories;
export var getRequirementCategoriesApplicationStageAction = jsonApi.getRequirementCategoriesApplicationStage;
export var getPaymentRequirementCategoriesAction = jsonApi.getPaymentRequirementCategories;
export var getMultipleApplicationsAction = jsonApi.getMultipleApplications;
export var createBulkNotesAction = jsonApi.createBulkNotes;
export var postApplicationRequirementFromTemplateAction = jsonApi.postApplicationRequirementFromTemplate;
export var patchApplicationRequirementQuestionAction = jsonApi.patchApplicationRequirementQuestion;
export var postApplicationRequirementAction = jsonApi.postApplicationRequirement;
export var deleteApplicationRequirementAdditionalAttachmentAction = jsonApi.deleteApplicationRequirementAdditionalAttachment;
export var deleteApplicationRequirementExternalLinkAction = jsonApi.deleteApplicationRequirementExternalLink;
export var postApplicationRequirementQuestionAction = jsonApi.postApplicationRequirementQuestion;
export var deleteApplicationRequirementQuestionAction = jsonApi.deleteApplicationRequirementQuestion;
export var getRequirementTemplateListAction = jsonApi.getRequirementTemplateList;
export var patchApplicationRequirementOptionalAction = jsonApi.patchApplicationRequirementOptional;
export var patchApplicationRequirementRequiredAction = jsonApi.patchApplicationRequirementRequired;
export var patchApplicationRequirementInactiveAction = jsonApi.patchApplicationRequirementInactive;
export var patchApplicationRequirementAnswerAction = jsonApi.patchApplicationRequirementAnswer;
export var postApplicationRequirementAnswerAction = jsonApi.postApplicationRequirementAnswer;
export var getCancellationReasonsAction = jsonApi.getCancellationReasons;
export var getApplicationAction = jsonApi.getApplication;
export var getSingleApplicationRequirementAction = jsonApi.getSingleApplicationRequirement;
export var updateAttachmentAction = jsonApi.updateAttachment;
export var patchApplicationRequirementApproveAnswerAction = jsonApi.patchApplicationRequirementApproveAnswer;
export var patchApplicationRequirementDisapproveAnswerAction = jsonApi.patchApplicationRequirementDisapproveAnswer;
export var patchApplicationRequirementAnswerStatusNoteAction = jsonApi.patchApplicationRequirementAnswerStatusNote;
export var patchApplicationRequirementAction = jsonApi.patchApplicationRequirement;
export var patchApplicationRequirementReviewStatusAction = jsonApi.patchApplicationRequirementReviewStatus;
export var patchApplicationRequirementApproveStatusAction = jsonApi.patchApplicationRequirementApproveStatus;
export var patchApplicationRequirementDisapproveStatusAction = jsonApi.patchApplicationRequirementDisapproveStatus;

// ApplyProof
export var getApplicationVerifiedDocumentsAction = jsonApi.getApplicationVerifiedDocuments;

// Application requirements
export var getApplicationRequirementsAction = jsonApi.getApplicationRequirements;
export var postIeltsResultsAction = jsonApi.postIeltsResults;

// -- DUPLICATED FROM ab-common -- //
export var getConditionOperationsAction = jsonApi.getConditionOperations;
export var getStudentTestScoresAction = jsonApi.getStudentTestScores;
export var getEducationHistoriesAction = jsonApi.getEducationHistories;
export var getStudentCustomFieldsAction = jsonApi.getStudentCustomFields;
export var getApplicationCustomFieldsAction = jsonApi.getApplicationCustomFields;
export var getCountriesAction = jsonApi.getCountries;
export var getConditionTemplateAction = jsonApi.getConditionTemplate;
export var getConditionResourcesAttributesAction = jsonApi.getConditionResourcesAttributes;
export var patchConditionTemplateAction = jsonApi.patchConditionTemplate;
export var postConditionTemplateAction = jsonApi.postConditionTemplate;
export var getNoteTemplatesAction = jsonApi.getNoteTemplates;
export var getNoteTemplatesTagDefinitionsAction = jsonApi.getNoteTemplatesTagDefinitions;
export var createNoteTemplateAction = jsonApi.createNoteTemplate;
export var editNoteTemplateAction = jsonApi.editNoteTemplate;
export var destroyNoteTemplateAction = jsonApi.destroyNoteTemplate;
export var getSchoolProgramIntakesAction = jsonApi.getSchoolProgramIntakes;
export var getCustomFieldDefinitionsAction = jsonApi.getCustomFieldDefinitions;
export var destroyApplicationCustomFieldsAction = jsonApi.destroyApplicationCustomFields;
export var destroyStudentCustomFieldsAction = jsonApi.destroyStudentCustomFields;
export var patchApplicationCustomFieldsAction = jsonApi.patchApplicationCustomFields;
export var patchStudentCustomFieldsAction = jsonApi.patchStudentCustomFields;
export var postApplicationCustomFieldsAction = jsonApi.postApplicationCustomFields;
export var postStudentCustomFieldsAction = jsonApi.postStudentCustomFields;
export var createApplyStuEmailAction = jsonApi.createApplyStuEmail;

// ---- //

export default jsonApi;